export default __webpack_public_path__ + "static/media/ISWEC-8.562be309.pdf";